class ProductForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    this.productOptions = this.form.querySelectorAll('.product-options [name*="option"]')
    this.atcBtn = this.form.querySelector('.btn-atc')
    this.buyBtn = this.form.querySelector('.btn-buy')

    this.form.addEventListener('submit', event => this.onSubmit(event))

    this.productOptions.forEach(elem =>
      elem.addEventListener('change', event => this.onChangeProductOption(event)))

    this.buyBtn?.addEventListener('click', event => this.onClickBuyBtn(event))
  }

  async onChangeProductOption (event) {
    event.preventDefault()

    const selectedOptions = []

    this.productOptions.forEach(elem => {
      if (elem.type === 'radio' && elem.checked) {
        selectedOptions.push(elem.value)
      } else if (elem.type === 'select-one') {
        selectedOptions.push(elem.value)
      }
    })

    // console.log(selectedOptions)

    const selectedVariant = JSON.parse(this.form.dataset.variants).find(variant =>
      JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    )

    console.log(selectedVariant)

    this.adjustPricing(selectedVariant)
    this.adjustButtons(selectedVariant)

    if (selectedVariant) {
      this.querySelector('[name="id"]').value = selectedVariant.id

      if (this.closest('.product-main')) {
        const url = new URL(window.location)
        url.searchParams.set('variant', selectedVariant.id)
        window.history.replaceState({}, '', url)
      }

      window.dispatchEvent(new CustomEvent('kt.product.variant.change', {
        detail: selectedVariant
      }))
    }
  }

  adjustPricing (selectedVariant) {
    if (!selectedVariant) return

    const comparePrice = this.form.querySelector('.product-price-compare')
    const finalPrice = this.form.querySelector('.product-price-final')
    const compareBadge = this.form.querySelector('.product-sale-badge')
    const soldOutBadge = this.form.querySelector('.product-sold-out-badge')

    if (selectedVariant.compare_at_price > selectedVariant.price) {
      comparePrice.textContent = window.Shopify.formatMoney(selectedVariant.compare_at_price)
      comparePrice.removeAttribute('hidden')
      finalPrice.innerHTML = `<span class="visually-hidden">${window.theme.locales.product.sale_price}}</span>${window.Shopify.formatMoney(selectedVariant.price)}`
      finalPrice.classList.add('product-price-final-sale')
      compareBadge.removeAttribute('hidden')
      if (compareBadge.dataset.discountType === 'percentage') {
        const savings = 100 - (Math.round(selectedVariant.price / selectedVariant.compare_at_price * 100)) + '%'
        compareBadge.textContent = `${window.theme.locales.product.save} ${savings}`
      } else {
        const savings = window.Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price)
        compareBadge.textContent = `${window.theme.locales.product.save} ${savings}`
      }
    } else {
      comparePrice.textContent = ''
      comparePrice.setAttribute('hidden', 'hidden')
      finalPrice.innerHTML = window.Shopify.formatMoney(selectedVariant.price)
      finalPrice.classList.remove('product-price-final-sale')
      compareBadge.textContent = ''
      compareBadge.setAttribute('hidden', 'hidden')
    }

    if (selectedVariant.available) {
      soldOutBadge.setAttribute('hidden', 'hidden')
    } else {
      soldOutBadge.removeAttribute('hidden')
    }
  }

  adjustButtons (selectedVariant) {
    if (selectedVariant) {
      if (selectedVariant.available) {
        this.atcBtn.removeAttribute('disabled')
        this.buyBtn?.removeAttribute('disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.add_to_cart
      } else {
        this.atcBtn.setAttribute('disabled', 'disabled')
        this.buyBtn?.setAttribute('disabled', 'disabled')
        this.atcBtn.innerHTML = window.theme.locales.product.sold_out
      }
    } else {
      this.atcBtn.setAttribute('disabled', 'disabled')
      this.buyBtn?.setAttribute('disabled', 'disabled')
      this.atcBtn.innerHTML = window.theme.locales.product.unavailable
    }
  }

  async onSubmit (event) {
    event.preventDefault()

    this.atcBtn.classList.add('loading')
    this.atcBtn.disabled = true
    this.atcBtn.setAttribute('aria-busy', 'true')

    const formData = new FormData(this.form)

    await document.querySelector('cart-container').add(formData)

    this.atcBtn.classList.remove('loading')
    this.atcBtn.disabled = false
    this.atcBtn.setAttribute('aria-busy', 'false')
  }

  onClickBuyBtn () {
    this.buyBtn.classList.add('loading')
    const variantId = this.form.querySelector('[name="id"]').value
    const qty = Number(this.form.querySelector('input[name="quantity"]')?.value || 1)
    window.location.href = `/cart/${variantId}:${qty}`
  }
}
customElements.define('product-form', ProductForm)

class ProductMediaGallery extends HTMLElement {
  constructor () {
    super()

    const initialSlide = Number(this.dataset.initialSlide)

    /** @type {Swiper} */
    this.thumbs = new window.Swiper(this.querySelector('.swiper-thumbs'), this.thumbsOptions())

    /** @type {Swiper} */
    this.main = new window.Swiper(this.querySelector('.swiper-main'), this.mainOptions())

    this.main.slideTo(initialSlide)

    this.setStickyPosition()
    this.listenVariantChange()
  }

  thumbsOptions () {
    /** @type {SwiperOptions} */
    const options = {
      slidesPerView: 6,
      spaceBetween: '14',
      direction: 'vertical',
      mousewheel: true
    }
    return options
  }

  mainOptions () {
    /** @type {SwiperOptions} */
    const options = {
      effect: this.dataset.effect,
      speed: Number(this.dataset.speed),
      rewind: false,
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: 'bullets',
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      navigation: {
        enabled: this.dataset.sliderNavigation === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      thumbs: {
        swiper: this.thumbs,
        autoScrollOffset: 1
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 0 },
        600: { slidesPerView: 1, spaceBetween: 0 },
        1200: { slidesPerView: 1, spaceBetween: 0 }
      }
    }
    return options
  }

  setStickyPosition () {
    if (this.closest('.product-main') && window.matchMedia('(min-width: 1200px)').matches) {
      const headerGroup = document.querySelector('#header-group.sticky-top')

      document.querySelector('.product-inner').style.position = 'sticky'
      document.querySelector('.product-inner').style.top = `${headerGroup.clientHeight - 2}px`
    }
  }

  listenVariantChange () {
    window.addEventListener('kt.product.variant.change', (event) => {
      const selectedVariant = event.detail

      if (selectedVariant.featured_media) {
        this.main.slideTo(selectedVariant.featured_media.position - 1)
      }
    }, false)
  }
}
customElements.define('product-media-gallery', ProductMediaGallery)

class ProductCardGallery extends HTMLElement {
  constructor () {
    super()

    /** @type {Swiper} */
    this.main = new window.Swiper(this, this.mainOptions())
  }

  mainOptions () {
    /** @type {SwiperOptions} */
    const options = {
      speed: 300,
      rewind: false,
      navigation: {
        enabled: true,
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      scrollbar: {
        enabled: true,
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      }
    }
    return options
  }
}
customElements.define('product-card-gallery', ProductCardGallery)

class KlaviyoStockNotifier extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input')
    this.alert = this.querySelector('.alert')
    this.querySelector('.btn').addEventListener('click', (e) => {
      e.preventDefault()
      this.onSubmit()
    })
  }

  async onSubmit () {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.input.value
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${this.dataset.variantId}`
            }
          }
        }
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15'
      },
      body: JSON.stringify(payload)
    }

    const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=SnHheF', requestOptions)
    console.log(response)

    if (response.ok) {
      this.alert.textContent = this.dataset.textSuccess
      this.alert.classList.remove('alert-warning')
      this.alert.classList.add('alert-success')
    } else {
      const data = await response.json()
      console.log(data)

      this.alert.textContent = data.errors[0].detail
      this.alert.classList.remove('alert-success')
      this.alert.classList.add('alert-warning')
    }

    this.alert.removeAttribute('hidden')
  }
}
customElements.define('klaviyo-stock-notifier', KlaviyoStockNotifier)

class KlaviyoComingSoonNotifier extends HTMLElement {
  constructor () {
    super()
    console.log('test')

    this.input = this.querySelector('input')
    this.alert = this.querySelector('.alert')
    this.querySelector('.btn').addEventListener('click', (e) => {
      console.log('click')
      e.preventDefault()
      this.onSubmit()
    })
  }

  async onSubmit () {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Coming soon',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: this.input.value
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'VzBJE5'
            }
          }
        }
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-07-15'
      },
      body: JSON.stringify(payload)
    }

    const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SnHheF', requestOptions)
    console.log(response)

    if (response.ok) {
      this.alert.textContent = this.dataset.textSuccess
      this.alert.classList.remove('alert-warning')
      this.alert.classList.add('alert-success')
    } else {
      const data = await response.json()
      console.log(data)

      this.alert.textContent = data.errors[0].detail
      this.alert.classList.remove('alert-success')
      this.alert.classList.add('alert-warning')
    }

    this.alert.removeAttribute('hidden')
  }
}
customElements.define('klaviyo-coming-soon-notifier', KlaviyoComingSoonNotifier)
